import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";


const TITLE = "Générateur de nombres aléatoires";
const DESCRIPTION =
  "Générateur de nombres aléatoires. Outil en ligne en francais pour obtenir un resultat rapide, clair et utile dans vos besoins du quotidien.";
const KEYWORDS =
  "name generator, calculatrice en ligne, outil pratique, utilitaire quotidien, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/random-number-generator/";

function RandomNumberGenerator() {
  const [min, setMin] = useState("1");
  const [max, setMax] = useState("100");
  const [count, setCount] = useState("1");
  const [numbers, setNumbers] = useState([]);

  const generate = () => {
    const minNum = parseInt(min) || 0;
    const maxNum = parseInt(max) || 100;
    const countNum = parseInt(count) || 1;
    const generated = [];

    for (let i = 0; i < countNum; i++) {
      const randomNum = Math.floor(Math.random() * (maxNum - minNum + 1) + minNum);
      generated.push(randomNum);
    }
    setNumbers(generated);
  };

  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>Cet outil genere des nombres aleatoires dans une plage que vous definissez. Saisissez les valeurs minimale et maximale, choisissez la quantite voulue, puis cliquez sur Generer pour obtenir vos resultats instantanement.</p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group">
                    <label>Minimum:</label>
                    <input type="number" value={min} onChange={(e) => setMin(e.target.value)} className="form-control" />
                  </div>
                  <div className="form-group">
                    <label>Maximum:</label>
                    <input type="number" value={max} onChange={(e) => setMax(e.target.value)} className="form-control" />
                  </div>
                  <div className="form-group">
                    <label>Quantité:</label>
                    <input type="number" value={count} onChange={(e) => setCount(e.target.value)} className="form-control" />
                  </div>
                  <button onClick={generate} className="btn btn-success w-100">Générer</button>
                </div>
              </div>
              <div className="col-sm-12 col-md-6">
                {numbers.length > 0 && (
                  <div className="bg-light p-3 rounded">
                    <h3>Nombres générés</h3>
                    <p style={{ fontSize: "20px", fontWeight: "bold" }}>{numbers.join(" | ")}</p>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>A quoi servent les nombres aleatoires</h3></div>
              <div className="info-section-body"><p>Les nombres aleatoires sont utilises dans les loteries, les simulations, les jeux, les tests et le chiffrement. Ils permettent d obtenir des valeurs imprevisibles et non biaisees.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseil d utilisation</h3></div>
              <div className="info-section-body"><p>Pour generer plusieurs nombres distincts, augmentez la quantite et assurez-vous que la plage est suffisamment large. Si la plage est etroite, des repetitions peuvent apparaitre.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Nature de l aleatoire</h3></div>
              <div className="info-section-body"><p>Les nombres generes par cet outil sont pseudo-aleatoires, produits par un algorithme mathematique. Ils conviennent a la plupart des usages courants.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RandomNumberGenerator;